"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translate = void 0;
/* istanbul ignore next: todo: test */
function translate(key, replaces) {
    //eslint-disable-next-line prefer-named-capture-group
    return key.replace(/\{\{([^}]+)\}\}/gi, function (_match, k) {
        return replaces[k.trim()] || '';
    });
}
exports.translate = translate;
//# sourceMappingURL=Translate.js.map